import { useApiRead } from "source/shared/SessionApiResource"

export function useFirstPageOfLeaders(group) {
  return useApiRead(
    `/groups/v2/me/groups/${group.id}/memberships?where[role]=leader`,
  )
}
